import { MarketingCompensatedDiscountsProductsGridPluginSettings } from "./MarketingCompensatedDiscountsProducts/MarketingCompensatedDiscountsProductsPluginSettings";

export const MarketingCompensatedDiscountsGridPluginSettings: IPluginSettings = {
    name: 'Компенсируемые скидки',
    mnemocode: 'marketing_compensated_discounts_plugin',
    permission: 'MarketingCompensatedDiscounts',
    detailsPlugins: [
        MarketingCompensatedDiscountsProductsGridPluginSettings,        
    ],
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'idGlobal',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'code',
                propertyType: 'string',
                displayName: 'Код группы товаров',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'name',
                propertyType: 'string',
                displayName: 'Наименование',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'dateFrom',
                propertyType: 'datetime',
                displayName: 'Действует с',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateTo',
                propertyType: 'datetime',
                displayName: 'Действует по',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'discountTypeText',
                propertyType: 'string',
                displayName: 'Единица измерения скидки',
                visibility: true,
                width: 250
            },
            {
                order: index++,
                propertyName: 'isMyHealthOnly',
                propertyType: 'boolean',
                displayName: 'Только для участника "Мое здоровье"',
                visibility: false,
                width: 200
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            }
        ]
        
    })()
};